import {Routes} from "@angular/router";

export const MEAL_PLAN_MODELS = "meal-plan-models";
export const MENU_PLANNING = "menu-planning";
export const MENU_TEMPLATES = "menu-templates";
export const ROUGH_PLANNING = "rough-planning";
export const SETTINGS = "settings";

export const routes: Routes = [
    {
        path: MEAL_PLAN_MODELS,
        loadChildren: async () => import("./pages/meal-plan-model/meal-plan-model.routes").then((mealPlanModelRoutes) => mealPlanModelRoutes.routes),
    },
    {
        path: MENU_PLANNING,
        loadChildren: async () => import("./pages/menu-planning/menu-planning.routes").then((menuPlanningRoutes) => menuPlanningRoutes.routes),
    },
    {
        path: MENU_TEMPLATES,
        data: {
            template: true,
        },
        loadChildren: async () => import("./pages/menu-planning/menu-planning.routes").then((menuPlanningRoutes) => menuPlanningRoutes.routes),
    },
    {
        path: ROUGH_PLANNING,
        loadChildren: async () => import("./pages/rough-planning/rough-planning.routes").then((roughPlanningRoutes) => roughPlanningRoutes.routes),
    },
    {
        path: SETTINGS,
        loadComponent: async () => import("./pages/settings/settings.component").then(({SettingsComponent}) => SettingsComponent),
    },
    {
        path: "**",
        loadComponent: async () => import("./pages/home/home.component").then(({HomeComponent}) => HomeComponent),
    },
];
